import FencelineSettings from "@/apps/fenceline/app.config"
import homeSettings from "@/apps/home/app.config"
import supportSettings from "@/apps/tutorials/app.config"

var generateConfig = (appSettings) => {
    var result = {
        name : appSettings.name,
        route : appSettings.parentRoute,
        icon: appSettings.icon,
        description : appSettings.description,
        color : appSettings.accentColor,
        children : appSettings.navigation.map(nav => {
            return {
                name : nav.title,
                route : `${appSettings.parentRoute}/${nav.route}`,
                icon: nav.icon,
            }
        })
    };
    // console.log(result);
    return result;
};
const apps = [
    homeSettings,
    FencelineSettings,
    supportSettings,
].map(app => generateConfig(app));

// console.log(apps);
// debugger;

export default apps


// {
//     name : "Tutorials",
//     route : "/tutorials",
//     icon:"mdi-school",
//     description : "Your home page",
//     color : 'blue darken-2'
// },

